import { useAnim, useSEO } from "../hooks.jsx";
import { Link } from "react-router-dom";
import { Ic } from "../icons.jsx";
import { FEATURES, PAGE_SEO, breadcrumb } from "../data.js";
import MockBrowser from "../components/MockBrowser.jsx";
import CtaBand from "../components/CtaBand.jsx";
import GuideLinks from "../components/GuideLinks.jsx";
import Breadcrumb from "../components/Breadcrumb.jsx";

const BC_ITEMS = [{ name: "Funzionalità", path: "/funzionalita" }];

// Approfondimento testuale, non solo card: le pagine-vetrina con soli elenchi
// puntati tendono a posizionarsi peggio di pagine con contenuto scritto.
const APPROFONDIMENTI = [
  {
    t: "Un gestionale pensato per il noleggio italiano",
    d: "Molti gestionali generici si limitano a calendario e fatturazione. NoleggioinCloud aggiunge quello che serve davvero a chi noleggia auto e moto in Italia: contratti PDF pronti per la firma e, quando previsto, l'invio automatico dei dati del contratto al portale CaRGOS della Polizia di Stato. Non è un modulo a parte da configurare altrove: è collegato alla stessa prenotazione e alla stessa scheda cliente che già usi ogni giorno.",
  },
  {
    t: "Dalla prenotazione al contratto, senza ridigitare nulla",
    d: "Quando un cliente prenota dal sito incluso, i suoi dati restano gli stessi fino alla consegna del veicolo: compaiono nel contratto PDF, nella scheda cliente e, se attivo, nella comunicazione a CaRGOS. Meno passaggi manuali significa meno probabilità di errore, soprattutto nei periodi con più prenotazioni.",
  },
  {
    t: "Cresce con la tua attività",
    d: "Il piano Base copre chi ha una decina di veicoli e vuole smettere di usare Excel e WhatsApp; il Pro aggiunge margine per una flotta più ampia; il Business Pro porta dominio personalizzato e hosting per chi vuole un sito indistinguibile da uno costruito su misura. Puoi cambiare piano quando vuoi, senza perdere dati.",
  },
];

export default function Funzionalita({ go }) {
  useAnim();
  useSEO({ ...PAGE_SEO.funzionalita, schema: breadcrumb([{ name:"Funzionalità", path:"/funzionalita" }]) });

  return (
    <>
      <Breadcrumb items={BC_ITEMS} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Funzionalità</div>
          <h1 className="h2" style={{ fontSize:"clamp(1.9rem,4vw,2.9rem)" }}>
            Tutto quello che serve<br /><mark>al tuo noleggio</mark>
          </h1>
          <p className="lead" style={{ marginTop:".65rem" }}>
            Dalla flotta al pagamento, dal calendario al contratto.
            NoleggioinCloud copre ogni aspetto del tuo autonoleggio o motonoleggio.
          </p>
        </div>
      </section>

      {/* All feature cards */}
      <section className="sec" style={{ background:"var(--bg)" }}>
        <div className="wrap">
          <div className="fg">
            {FEATURES.map((f, i) => (
              <article className={`fc an d${(i % 3) + 1}`} key={f.t}>
                <div className={`fi ${f.c}`}><Ic n={f.i} s={21} /></div>
                <h3 className="ft">{f.t}</h3>
                <p className="fd">{f.d}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Approfondimento testuale */}
      <section className="sec">
        <div className="wrap" style={{ maxWidth: 820 }}>
          {APPROFONDIMENTI.map((a) => (
            <div key={a.t} className="an" style={{ marginBottom: "1.75rem" }}>
              <h2 style={{ fontSize: "1.15rem", marginBottom: ".4rem" }}>{a.t}</h2>
              <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75 }}>{a.d}</p>
            </div>
          ))}
          <p className="an" style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75 }}>
            Per approfondire i due aspetti più richiesti, ci sono due guide dedicate:{" "}
            <Link to="/gestionale-noleggio-cargos-polizia">gestionale con CaRGOS e Polizia</Link>{" "}
            e <Link to="/gestionale-noleggio-moto">gestionale per il noleggio moto</Link>.
          </p>
        </div>
      </section>

      {/* Sito incluso spotlight */}
      <section className="sec">
        <div className="wrap">
          <div className="spot-grid">
            <div className="an">
              <div className="chip">Sito incluso</div>
              <h2 className="h2">Il sito è già pronto.<br /><mark>Con il tuo brand</mark></h2>
              <p style={{ fontSize:".95rem", color:"var(--muted)", lineHeight:1.75, margin:"1rem 0 1.5rem" }}>
                Ogni licenza include un sito di prenotazione personalizzabile,
                subito online, accessibile da qualsiasi dispositivo.
              </p>
              {[
                "Logo e nome azienda",
                "Catalogo auto e moto separati",
                "Filtro disponibilità per date",
                "Pagamento online Stripe",
                "Storico prenotazioni per il cliente",
                "Login con Google o email",
              ].map(p => (
                <div key={p} style={{ display:"flex", alignItems:"center", gap:".55rem", marginBottom:".6rem", fontSize:".9rem", color:"var(--body)" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="var(--green)" strokeWidth="2.5" strokeLinecap="round">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                  {p}
                </div>
              ))}
              <Link to="/prezzi" className="btn btn-p" style={{ marginTop:"1.25rem", textDecoration:"none" }}>
                Prova gratis <Ic n="arrow" s={16} />
              </Link>
            </div>
            <div className="an d2">
              <MockBrowser type="moto" />
            </div>
          </div>
        </div>
      </section>

      <GuideLinks />

      <CtaBand go={go} />
    </>
  );
}
